var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutUsBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    width: 7455.022,
    height: 6018.266,
    viewBox: "0 0 7455.022 6018.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4220",
    "data-name": "Path 4220",
    d: "M5824.954,1252.347c-707.574,103.667-1416.237,47.833-2098.441-29.4S2363.691,1047.1,1654.63,1066.233c-455.86,12.436-962.954,91.057-1278.389,332.309C72.8,1630.749,29.391,1948.1,32.265,2235.01c2.18,215.944,25.27,439.542,191.858,613.045,115.65,120.539,292.444,207.943,426.13,319.35,465.77,387.708,333.669,988.316,38.748,1497-138.74,238.555-308.3,472.85-401.355,717.408s-102.271,508.334,73.136,711.233c173.821,200.725,506.3,316.48,852.26,378.4,702.52,125.843,1482.238,60.878,2236.389-29.4,1669.14-201.159,2392.671-461.822,4037.729-786.216,0-791.714,0-4502.4,0-5132.637C7146.154,912.645,6449.68,1160.855,5824.954,1252.347Z",
    transform: "translate(-32.137 -523.198)",
    fill: "#0e7f8a",
    opacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsBack);
export default __webpack_public_path__ + "static/media/AboutUsBack.9175415368e01957176baf59763abf62.svg";
export { ForwardRef as ReactComponent };